import {OrderEntry, OrderSheetPageSet} from '@web/core/constants'
import {Sentry} from '@web/helpers/log'
import {sendOrderRejectToNelo} from '@web/helpers/nelo'
import {errorLoggerCreator} from '@web/middlewares/logger'

import {initOrderSheet} from '../../../actions/familyPay'
import {MemberRootState as RootState} from '../../../interfaces'

const errorLoggerMiddleware = errorLoggerCreator<RootState>({
    callbackActionError: ({action}) => {
        const code = action.error?.code ?? ''
        if (
            // initOrderSheetByApi 에러로 인한 action reject 수집 방지
            action.type === initOrderSheet.rejected.type &&
            ['VALIDATION_FAILED', 'ORDER_SHEET_NOT_FOUND', 'INQUIRE_ORDER_SHEET_FAILED'].includes(code)
        ) {
            return
        }
        const message = (function () {
            const result = `${action.type}`
            const errorMessage: string = action.error?.message ?? action.error?.stack ?? ''
            if (errorMessage) {
                return `${result} : ${errorMessage}`
            }
            return result
        })()

        sendOrderRejectToNelo({
            entry: OrderEntry.FAMILY_PAY,
            pageSet: OrderSheetPageSet.FAMILY_PAY,
            message,
        })
        Sentry.sendMessage(message)
    },
    callbackSliceError: ({action, error}) => {
        const message = (function () {
            const result = `${action.type}`
            if (error) {
                const errorMessage: string = error.message ?? error.stack ?? null
                return `${result} : ${errorMessage}`
            }
            return result
        })()

        sendOrderRejectToNelo({
            entry: OrderEntry.FAMILY_PAY,
            pageSet: OrderSheetPageSet.FAMILY_PAY,
            message,
        })
        if (error) {
            Sentry.sendGeneralError(error)
        } else {
            Sentry.sendMessage(message)
        }
    },
})

export default errorLoggerMiddleware
